import isEqual from "lodash/isEqual";
import omit from "lodash/omit";
import uniqWith from "lodash/uniqWith";

import type { NapiV2Passenger } from "@app/types/napi-v2-passengers-types";
import type { NapiV2Purchase } from "@app/types/napi-v2-purchase-types";
import { isTicketPurchaseItem } from "@app/types/napi-v2-purchase-types";

export function getPurchaseTotalPassengersCount(
  purchase: NapiV2Purchase
): number {
  return getPurchaseUniqPassengers(purchase).length;
}

export function getPurchasePassengersCategoryCounts(
  purchase: NapiV2Purchase
): Record<NapiV2Passenger["category"], number> {
  const uniq_passengers = getPurchaseUniqPassengers(purchase);

  return [...uniq_passengers].reduce(
    (passengers_count, passenger) => {
      if (passengers_count[passenger.category]) {
        passengers_count[passenger.category] += 1;
      } else {
        passengers_count[passenger.category] = 1;
      }

      return passengers_count;
    },
    { adult: 0, youth: 0, senior: 0 }
  );
}

function getPurchaseUniqPassengers(
  purchase: NapiV2Purchase
): Omit<NapiV2Passenger, "answers" | "selected_seats">[] {
  // Passengers with same name/age/category are considered the same passenger
  // and should be counted only once even if they have multiple items in the purchase
  // (e.g. round-trip).
  return uniqWith(
    purchase.items
      .filter(isTicketPurchaseItem)
      // We also omit the answers and selected_seats fields which may vary on different trip for the same passenger
      .map(item => omit(item.passenger, ["answers", "selected_seats"])),
    isEqual
  );
}
